var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.727,
    height: 14.727,
    viewBox: "0 0 14.727 14.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22332",
    "data-name": "Group 22332",
    transform: "translate(-22.5 -57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27690",
    "data-name": "Path 27690",
    d: "M9.363,2A7.363,7.363,0,1,1,2,9.363H3.473A5.89,5.89,0,1,0,4.492,6.05H6.418V7.522H2V3.1H3.473V4.945A7.349,7.349,0,0,1,9.363,2ZM10.1,5.682V9.058l2.388,2.388-1.042,1.042L8.627,9.667V5.682Z",
    transform: "translate(20.5 55)",
    fill: "#6d4eec"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6b28a28a04ecef38145fdac79b8f0caf.svg";
export { ForwardRef as ReactComponent };